import React, { useState } from "react";
import CommandPanel from "../../CommandPanel/CommandPanel";
import { PlateAddress } from "./../../../Model/PlateAddress";
import StorageApi from "./../../../api/StorageApi";
import MtiButton from "../../Buttons/MtiButton";

type Props = {
  plateAddress: PlateAddress;
  style?: React.CSSProperties;
  backBtn: () => void;
};

export default function HandScan({ plateAddress, backBtn, style = {} }: Props) {
  const [barcode, setBarcode] = useState("");

  var handleOK = () => {
    const moduleIdentifier = plateAddress.moduleIdentifier;
    const hotelNo = plateAddress.hotelNo;
    const slotNo = plateAddress.slotNo;
    StorageApi.handScan(moduleIdentifier, hotelNo, slotNo, barcode);
    backBtn();
  };

  var handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleOK();
    }
  };

  return (
    <CommandPanel
      style={{
        ...style,
      }}
    >
      <CommandPanel.PlateInfoHeader plateAddresses={[plateAddress]} />
      <CommandPanel.BackArrowHeader title="Hand Scan" onBackArrowClick={backBtn} />
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          paddingRight: 30,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              flexGrow: 1,
              fontSize: "20px",
            }}
          >
            Input Barcode
          </div>
          <div style={{ fontSize: "20px" }}>:</div>
          <input
            onChange={(e) => setBarcode(e.target.value)}
            value={barcode}
            autoFocus
            style={{
              flexGrow: 1,
              minHeight: 51,
              marginLeft: 13,
              fontSize: "20px",
              paddingLeft: "10px",
            }}
            type="text"
            id="barcodeInput"
            onKeyDown={handleKeyDown}
          />
        </div>
        <div
          style={{
            marginTop: 27,
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "stretch",
            height: 66,
          }}
        >
          <MtiButton
            onClick={handleOK}
            style={{
              width: 190,
              fontSize: 27,
            }}
          >
            OK
          </MtiButton>
        </div>
      </div>
    </CommandPanel>
  );
}
